import React, { useState, useEffect } from "react";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import "./TitleWithSearch.css";

const TitleWithSearch = ({ title, onSearch, placeholder, type = "text" }) => {
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (searchQuery.length > 1) {
      const timer = setTimeout(() => {
        onSearch(searchQuery);
      }, 1000); // 1-second delay

      return () => clearTimeout(timer);
    } else {
      onSearch("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <div className="TitleWithSearchBox">
      <h2 className="MainTitle">{title}</h2>
      <label className="SearchBox">
        <SEARCHICON className="SearchIcon" />
        <input
          className="SearchInput lg:w-fit w-full"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          type={type}
        />
      </label>
    </div>
  );
};

export default TitleWithSearch;
